

export const selectedSitesActions = {
    setSelectedSitesFleet({ commit }, payload) {
        commit('SET_SELECTED_SITES_FLEET', payload);
      }

};
